import { useNavigate, useSearchParams } from "react-router-dom";
import MobileHeader from "../../component/MobileHeader";
import "../../css/diagnostic/datelist.css";
import { useEffect, useRef, useState } from "react";
import axios from "axios";
import flatpickr from "flatpickr";
import { Korean } from "flatpickr/dist/l10n/ko.js";
import "flatpickr/dist/flatpickr.min.css";

export default function DateList() {
    const navigate = useNavigate();
    const API = process.env.REACT_APP_API_BASE_URL;
    const token = localStorage.getItem("accessToken") || "";

    const [userInfo, setUserInfo] = useState({
        regId: "",
        regNM: "",
        phoneNumber: "",
        aboveIdx: "",
        aboveNM: "",
        fldIdx: "",
        fldNM: "",
    });

    const [aboveIdx, setAboveIdx] = useState("");
    const [userFldIdx, setUserFldIdx] = useState("");
    const [searchParams] = useSearchParams();
    const [dateType, setDateType] = useState("inspection");

    const fieldName = searchParams.get("fieldName");
    const days = ["일", "월", "화", "수", "목", "금", "토"];
    const dateInputRef = useRef(null);

    const paramFldIdx = searchParams.get("fldIdx");
    const lineUid = searchParams.get("lineUid");

    const [dateList, setDateList] = useState([]);

    const [totalCount, setTotalCount] = useState(0);
    const [todayCount, setTodayCount] = useState(0);
    const [lastDate, setLastDate] = useState("-");

    useEffect(() => {
        axios
            .get(`${API}/userinf`, {
                headers: { Authorization: token },
            })
            .then((res) => {
                const data = res.data || {};
                const fldIdxValue = data.fldIdx || "";

                setUserInfo({
                    regId: data.regId || data.userId || data.uid || "",
                    regNM: data.regNM || data.userName || "",
                    phoneNumber: data.phoneNumber || data.mobile || data.hp || "",
                    aboveIdx: data.aboveIdx || "",
                    aboveNM: data.aboveContractor?.aboveNM || data.aboveNM || "",
                    fldIdx: fldIdxValue,
                    fldNM: data.field?.fldNM || data.fldNM || "",
                });

                setAboveIdx(data.aboveIdx || "");
                setUserFldIdx(fldIdxValue);
            })
            .catch((err) => {
                console.error("userinf error:", err?.response?.status, err?.response?.data);
                setUserInfo({
                    regId: "",
                    regNM: "",
                    phoneNumber: "",
                    aboveIdx: "",
                    aboveNM: "",
                    fldIdx: "",
                    fldNM: "",
                });
                setAboveIdx("");
                setUserFldIdx("");
            });
    }, [API, token]);

    useEffect(() => {
        if (!dateInputRef.current) return;

        const container = dateInputRef.current.parentElement;

        const fp = flatpickr(dateInputRef.current, {
            locale: Korean,
            clickOpens: true,
            allowInput: false,
            dateFormat: "Y-m-d",
            static: true,
            appendTo: container,
            disableMobile: true,
            onChange: (selectedDates, dateStr) => {
                if (dateStr) {
                    navigate(
                        `/mylistByDate?targetDate=${encodeURIComponent(dateStr)}&dateType=${encodeURIComponent(dateType)}`
                    );
                }
            },
        });

        return () => fp.destroy();
    }, [navigate, dateType]);

    useEffect(() => {
        if (!userFldIdx) return;

        axios
            .get(`${API}/selectDateByUser`, {
                params: {
                    dateType,
                },
                headers: {
                    "Content-type": "application/json",
                    Authorization: token,
                },
            })
            .then((resp) => {
                setDateList(Array.isArray(resp.data) ? resp.data : []);
            })
            .catch((err) => {
                console.error("selectDateByUser error:", err?.response?.status, err?.response?.data);
                setDateList([]);
            });
    }, [API, token, userFldIdx, dateType]);

    const handleMoveDate = (date) => {
        navigate(
            `/mylistByDate?targetDate=${encodeURIComponent(date)}&dateType=${encodeURIComponent(dateType)}`
        );
    };

    useEffect(() => {
        if (!userFldIdx) return;

        axios
            .get(`${API}/diagnosticSummary`, {
                params: {
                    dateType,
                },
                headers: { Authorization: token },
            })
            .then((res) => {
                const data = res.data || {};

                setTotalCount(data.totalCount || 0);
                setTodayCount(data.todayCount || 0);
                setLastDate(data.lastDate || "-");
            })
            .catch((err) => {
                console.error("diagnosticSummary error:", err?.response?.status, err?.response?.data);
            });
    }, [API, token, userFldIdx, dateType]);

    return (
        <div className="page">
            <div className="date_mobile">
                <MobileHeader onPrev={() => window.history.back()} />

                <section className="dl_profile_card">
                    <div className="dl_profile_top">
                        <div className="dl_profile_left">
                            <h2 className="dl_profile_name">{userInfo.regNM || "사용자"}</h2>
                            <p className="dl_profile_phone">{userInfo.phoneNumber || "휴대폰 번호 없음"}</p>
                        </div>

                        <div className="dl_profile_badge">
                            관리자
                        </div>
                    </div>

                    <div className="dl_profile_info_box">
                        <div className="dl_profile_info_item">
                            <span className="dl_profile_label">현장명</span>
                            <strong className="dl_profile_value">{userInfo.fldNM || "현장 정보 없음"}</strong>
                        </div>

                        <div className="dl_profile_info_item">
                            <span className="dl_profile_label">도급사</span>
                            <strong className="dl_profile_value">{userInfo.aboveNM || "업체 정보 없음"}</strong>
                        </div>

                        <div className="dl_profile_info_item2">
                            <span className="dl_profile_label">총 진단 건수</span>
                            <strong className="dl_profile_value">{totalCount}건</strong>
                        </div>

                        <div className="dl_profile_info_item3">
                            <span className="dl_profile_label">오늘 진단</span>
                            <strong className="dl_profile_value">{todayCount}건</strong>
                        </div>

                        <div className="dl_profile_info_item4">
                            <span className="dl_profile_label">최근 진단</span>
                            <strong className="dl_profile_value">{lastDate}</strong>
                        </div>
                    </div>
                </section>

                <main className="main">
                    <h1 className="title">점검 현황</h1>
                    <p className="sub_title">
                        조회할 날짜를 선택해주세요.
                        <br />
                        아래 목록 또는 달력에서 바로 이동할 수 있습니다.
                    </p>

                    <section className="dl_card">
                        <div className="dl_section_head">
                            <h2>날짜 검색</h2>
                            <span>캘린더 선택</span>
                        </div>

                        <div className="dl_date_type_toggle">
                            <button
                                type="button"
                                className={`dl_date_type_btn ${dateType === "inspection" ? "active" : ""}`}
                                onClick={() => setDateType("inspection")}
                            >
                                점검일로 선택
                            </button>

                            <button
                                type="button"
                                className={`dl_date_type_btn ${dateType === "occurrence" ? "active" : ""}`}
                                onClick={() => setDateType("occurrence")}
                            >
                                발생일로 선택
                            </button>
                        </div>

                        <div className="dl_searchbar">
                            <span
                                className="dl_search_icon"
                                onClick={() => dateInputRef.current?._flatpickr?.open()}
                            >
                                <img
                                    src="/images/달력 아이콘.png"
                                    width="20"
                                    height="20"
                                    alt="달력"
                                />
                            </span>

                            <input
                                ref={dateInputRef}
                                className="dl_calendar_input"
                                placeholder="날짜를 선택하세요"
                                readOnly
                                onClick={() => {
                                    dateInputRef.current?._flatpickr?.open();
                                }}
                            />
                        </div>
                    </section>

                    <section className="dl_card">
                        <div className="dl_section_head">
                            <h2>날짜 목록</h2>
                            <span>{dateList.length}건</span>
                        </div>

                        <div className="dl_list">
                            {dateList.length > 0 ? (
                                dateList.map((data, index) => {
                                    const weekday = days[new Date(data).getDay()];

                                    return (
                                        <button
                                            type="button"
                                            key={index}
                                            className="dl_date_item"
                                            onClick={() => handleMoveDate(data)}
                                        >
                                            <div className="dl_date_left">
                                                <div className="dl_date_icon">
                                                    <img
                                                        src="/images/달력 아이콘.png"
                                                        width="22"
                                                        height="22"
                                                        alt="달력"
                                                    />
                                                </div>

                                                <div className="dl_date_text_group">
                                                    <strong className="dl_date_text">{data}</strong>
                                                    <span className="dl_date_desc">
                                                        선택한 날짜의 점검 내역 보기
                                                    </span>
                                                </div>
                                            </div>

                                            <div className="dl_date_right">
                                                <span className="dl_weekday">{weekday}요일</span>
                                                <span className="dl_arrow">›</span>
                                            </div>
                                        </button>
                                    );
                                })
                            ) : (
                                <div className="dl_empty">
                                    <div className="dl_empty_icon">📅</div>
                                    <p>조회 가능한 날짜가 없습니다.</p>
                                </div>
                            )}
                        </div>
                    </section>
                </main>
            </div>
        </div>
    );
}